const Td = ({ data }) => {
  return (
    <td
      className={
        data.status === 1
          ? "center success"
          : data.status === 0
          ? "center error"
          : data.status === 4
          ? "center notice"
          : "center working"
      }
    >
      <div className="flex" style={{ justifyContent: "center" }}>
        <i
          className={
            data.status === 1
              ? "fa fa-check-circle"
              : data.status === 0
              ? "fa fa-times-circle"
              : data.status === 2
              ? "fa fa-hourglass-o"
              : data.status === 4
              ? "fa fa-clock-o"
              : "fa fa-info-circle"
          }
        />
        <span>{data.text.split(" ").shift()}</span>
      </div>
    </td>
  );
};

const Table2 = ({ invite }) => {
  return (
    <table className="approved assigned">
      <thead>
        <tr>
          <th colSpan="4" className="hdg">
            Invitation Status
          </th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td style={{ width: "25%" }}>
            <strong>Golf</strong>
          </td>
          <td style={{ width: "25%" }}>
            <strong>Sporting Clays</strong>
          </td>
          <td style={{ width: "25%" }}>
            <strong>Welcome Party</strong>
          </td>
          <td style={{ width: "25%" }}>
            <strong>Gift Package</strong>
          </td>
        </tr>
        <tr>
          <Td data={invite.golf} />
          <Td data={invite.sporting} />
          <Td data={invite.welcome} />
          <Td data={invite.gift} />
        </tr>
      </tbody>
    </table>
  );
};

export default Table2;
